module.exports = __webpack_public_path__ + "img/diptesh.ef784dd.webp";